import { UseMutateFunction } from "react-query";
import {
  QueriesTypes,
  usePutRequestFormData,
} from "../../../../common/hooks/queries";

export const useUpdateFollowUpAssessoria = ({
  onSettled,
}: {
  onSettled: (payload: any) => void;
}): [
  UseMutateFunction<
    any,
    unknown,
    {
      requestFormData: FormData;
    }
  >,
  boolean,
  boolean
] => {
  const { isLoading, isError, mutate } = usePutRequestFormData(
    QueriesTypes.FollowUps,
    { onSettledCallback: onSettled }
  );

  return [mutate, isLoading, isError];
};
